// extracted by mini-css-extract-plugin
module.exports = {"container":"EmptyInactivePurchases_container__mJD_p","content":"EmptyInactivePurchases_content__TJB2H"};